<div class="flex flex-col gap-6 pb-[10rem]">
  <div class="flex flex-row justify-between">
    <div class="w-full">
      <h1 class="main-title">Lista de resultados</h1>

      <!-- Selectores -->
      <div class="flex flex-row gap-4 mt-4">
        <!-- Selector de Año -->
        <div class="flex flex-col gap-2" style="width:150px">
          <label class="text-sm font-medium text-gray-700">Año</label>
          <p-datepicker
            [(ngModel)]="selectedYear"
            view="year"
            dateFormat="yy"
            placeholder="Seleccionar año"
            [showIcon]="true"
            [readonlyInput]="true"
            fluid>
          </p-datepicker>
        </div>

        <!-- Dropdown con Buscador (PCG) -->
        <div class="flex flex-col gap-2" style="width:150px">
          <label class="text-sm font-medium text-gray-700">PCG</label>
          <p-select
            [options]="pcgOptions"
            [(ngModel)]="selectedPCG"
            placeholder="Seleccionar PCG..."
            [filter]="true"
            filterBy="label"
            optionLabel="label"
            optionValue="value"
            fluid>
          </p-select>
        </div>

        <!-- Botón de Búsqueda -->
        <div class="flex flex-col gap-2 justify-end">
          <p-button
            label="Buscar"
            icon="pi pi-search"
            (onClick)="fetchReportResults()"
            [disabled]="!selectedYear || !selectedPCG"
            severity="primary">
          </p-button>
        </div>
      </div>
    </div>
  </div>

  <!-- Tabla de Resultados -->
  <p-blockui [blocked]="isLoading">
    <ng-template #content>
      <div class="flex flex-col items-center justify-center py-12">
        <p-progress-spinner class="w-12 h-12"></p-progress-spinner>
        <p class="mt-4 text-gray-600">Cargando resultados...</p>
      </div>
    </ng-template>
  </p-blockui>
  <app-results-list [data]="reportResults"></app-results-list>
</div>
